import type { PriceId } from '@iheartjane/types';

import type { AlgoliaProduct } from '@jane/search/types';
// eslint-disable-next-line no-restricted-imports
import type { MenuProduct } from '@jane/shared/models';
import type { MaterializedMenuProduct } from '@jane/shared/types';

interface Props {
  menuProduct: MenuProduct | AlgoliaProduct | MaterializedMenuProduct;
  priceId: PriceId;
}

export const getPriceIdBrandSpecial = ({ menuProduct, priceId }: Props) => {
  const brandSpecialPriceValues = Object.values(
    menuProduct?.brand_special_prices || {}
  ).filter(Boolean);

  if (
    !menuProduct.brand_special_prices ||
    brandSpecialPriceValues.length === 0 ||
    !menuProduct.has_brand_discount
  )
    return null;

  const priceIdSpecial = menuProduct.brand_special_prices?.[priceId];

  return priceIdSpecial;
};
